import cl from 'classnames'
import { ButtonHTMLAttributes } from 'react'
import styles from './styles.module.scss'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'outline-primary'
    | 'outline-secondary'
    | 'outline-tertiary'
}

export const HomeButton = ({
  variant = 'primary',
  className,
  ...rest
}: Props) => {
  return (
    <button
      className={cl(styles.buttonDefault, className)}
      data-variant={variant}
      {...rest}
    />
  )
}
